export enum StatusColorEnum {
  Success = "success",
  Warning = "warning",
  Danger = "danger",
}
